import {Injectable} from '@angular/core';
import { UrlTree } from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as fromPtCore from './../store/reducers/pt-core.reducer';
import {PtCoreActions, PtCoreSelectors} from '../store';
import {PtUiAppRoutes} from '@pt/pt-models';

@Injectable({
  providedIn: 'root'
})
export class ForbiddenGuardService  {
  constructor(private store: Store<fromPtCore.CoreState>) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.pipe(
      select(PtCoreSelectors.loginResponse),
      map((loginResponse) => {
        if (loginResponse) {
          this.store.dispatch(PtCoreActions.navigateTo({ route: [PtUiAppRoutes.HOME] }));
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
